function register( name, mod ) {
  register.registry[ name ] = mod;
}

register.registry = {};

export default register;
